import { Autocomplete, TextField } from "@mui/material";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

const CompanyDetailsForm = ({ formProps, selectedTeam, industriesList }) => {
  const { values, setFieldValue, touched, errors } = formProps;

  return (
    <>
      <MDBox mb={2}>
        <MDInput
          fullWidth
          variant="standard"
          name="companyName"
          label="Company name"
          value={values.companyName}
          onChange={(event) => {
            setFieldValue("companyName", event.target.value);
          }}
          helperText={touched.companyName && errors.companyName}
          error={touched.companyName && Boolean(errors.companyName)}
          disabled={Boolean(selectedTeam?.name)}
        />
      </MDBox>
      <MDBox mb={2}>
        <Autocomplete
          fullWidth
          id="industry"
          options={industriesList}
          value={values?.industry}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) => option?.value === value?.value}
          onChange={(_, option) => setFieldValue("industry", option || null)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Industry"
              variant="standard"
              error={touched.industry && Boolean(errors.industry)}
              helperText={touched.industry && (errors.industry?.value || errors.industry)}
              disabled={Boolean(selectedTeam?.name)}
            />
          )}
          disabled={Boolean(selectedTeam?.name)}
        />
      </MDBox>
    </>
  );
};

export default CompanyDetailsForm;
